import FeuilleRouteController from './feuille.route.controller';

export default {
    template: require('./feuille.route.html'),
    controller: FeuilleRouteController
};
